<script>
import store from '../store'
import configure from '../tools/configurator/configure'

export default {
  name: 'designSummary',
  data: () => ({
    // scenetitle: '',
    // header: '',
    // subheader: ''
  }),
  props: {
    scenetitle: String,
    header: String,
    subheader: String
  },
  computed: {
    showDialog: {
      get: function () {
        let modelState = this.$store.getters['model/getState']
        return modelState.designSummary
      },
      set: function (newValue) {
        store.commit('model/setProperty', {property: 'designSummary', value: newValue})
      }
    },
    materialSummary () {
      let modelState = this.$store.getters['model/getState']
      return modelState.materialSummary
    },
    optionSummary () {
      let modelState = this.$store.getters['model/getState']
      return modelState.optionSummary
    }
  },
  methods: {
    createDesignSummary () {
      configure.getScreenshot(function (result) {
        store.commit('model/setProperty', {property: 'screenshot', value: result})

        let optionSummary = ''
        let materialSummary = ''
        let state = store.getters['materialList/getState']
        for (let opt of state.materials) {
          materialSummary += ('&Tab;' + opt.currentTitle + '<br/>')
        }
        state = store.getters['visibilitySingleList/getState']
        for (let opt of state.visibilityoptionssingle) {
          optionSummary += ('&Tab;' + opt.title + ': ' + opt.visible + '<br/>')
        }
        state = store.getters['visibilityGroupList/getState']
        for (let opt of state.visibilityoptionsgroup) {
          // let visOption = opt.options.find(o => o.name === opt.visible)
          optionSummary += ('&Tab;' + opt.currentTitle + '<br/>')
        }

        store.commit('model/setProperty', {property: 'optionSummary', value: optionSummary})
        store.commit('model/setProperty', {property: 'materialSummary', value: materialSummary})
        store.commit('model/setProperty', {property: 'designSummary', value: true})
      })
    }
  }
}
</script>

<template>
  <md-dialog :md-active.sync="showDialog">
    <md-dialog-content>
      <md-card>
        <md-card-media-cover md-solid>
          <md-card-media>
            <img :src="$store.state.model.screenshot" alt="Product screenshot">
          </md-card-media>

          <md-card-area>
            <md-card-header>
              <div class="md-title">{{scenetitle}} Configuration Summary</div>
              <div class="md-subhead">{{header}}, {{subheader}}</div>
            </md-card-header>
          </md-card-area>
        </md-card-media-cover>

        <md-card-content>
          <div class="md-title">Materials</div>
          <div style="margin-left: 8px;" v-html="materialSummary"></div>
          <div class="md-title">Options</div>
          <div style="margin-left: 8px;" v-html="optionSummary"></div>
        </md-card-content>
      </md-card>

      <md-dialog-actions>
        <md-button class="md-accent md-raised" @click="showDialog = false">OK, cool</md-button>
      </md-dialog-actions>
    </md-dialog-content>
  </md-dialog>
</template>

<style lang="scss" scoped>
  .md-dialog {
    min-width: 600px;
    max-width: 600px;

    @media screen and (max-width: 768px) {
      min-width: 78%;
    }
  }
  .md-subheading {
    margin-left: 8px;
  }
  .md-headline {
    margin-left: 8px;
  }
</style>
